import { onDarkBase } from "@biom3/design-tokens";
import { NotificationsNone as NotificationsNoneIcon } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import type React from "react";

export const EmptyState: React.FC = () => {
  return (
    <Box
      sx={{
        padding: onDarkBase.spacing.x8,
        textAlign: "center",
      }}
    >
      <Stack
        direction="column"
        spacing={onDarkBase.spacing.x3}
        alignItems="center"
      >
        <NotificationsNoneIcon
          sx={{
            fontSize: "48px",
            color: onDarkBase.color.text.body.secondary,
            opacity: 0.3,
          }}
        />

        <Stack direction="column" spacing={onDarkBase.spacing.x1}>
          <Typography
            variant="body1"
            sx={{
              color: onDarkBase.color.text.body.secondary,
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            No recent activities
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: onDarkBase.color.text.body.secondary,
              fontSize: "12px",
              opacity: 0.8,
            }}
          >
            Complete quests to see your progress!
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
